<template>
    <v-content pa-0>
        <v-layout justify-start>
            <v-flex pt-5 pa-0>
                <Appbar style="padding-left: 0px"></Appbar>
            </v-flex>
        </v-layout>
        <v-container>
            <v-layout row justify-center align-center style="min-height: 250px">
                <v-flex mt-5 class="col-12 py-0">
                    <h1 style="text-align: center;font-size: 2.375rem;">"Crypto" for the new gig economy</h1>
                </v-flex>
                <v-flex class="col-sm-8 col-lg-9 col-xl-6 col-12 py-0" justify-center>
                    <p class="mb-5 px-12" style="text-align: center;font-size: 1.1rem">With over $32 million worth of Storm Tokens were sold during the 2017 Crowdsale, Storm Token is a premium cryptocurrency reward used to fuel the world’s only blockchain-supported microtask platform.</p>
                </v-flex>
            </v-layout>
        </v-container>
        <img style="width: 100%" :src="require('../assets/hero2.jpg')">
        <v-container style="padding-bottom: 0px">
            <v-layout row style="min-height: 500px" :style="$vuetify.breakpoint.smAndDown ? {'justify-content':' center'}:{'justify-content':'start'}">
                <v-flex offset-2 xl4 :class="{'col-10': $vuetify.breakpoint.smAndDown}" justify-center class="col-5" style="display: flex;padding-bottom: 0px">
                    <img style="width: 100%" :src="require('../assets/showcase.png')">
                </v-flex>
                <v-flex offset-xl1 xl3 class="col-4" :class="{'col-10': $vuetify.breakpoint.smAndDown,'pt-12' : $vuetify.breakpoint.smAndDown}">
                    <h1 style="font-size: 2.375rem" class="pt-12">Secure wallet. Safe places for your "crypto" rewards.</h1>
                    <p style="font-size: 1rem" class="pt-5">Use an ERC20-compatible wallet to manage your Storm Tokens. To get started download Jaxx, the official wallet for Storm Token.</p>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    import Appbar from "../components/Appbar"
    export default {
        name: "Token",
        components: {
        Appbar,
    },
    }
</script>

<style scoped>

</style>
